<section class="flex-column full-height bms-theme-content">
  <vdw-editor-header
    [identifier]="HEADER_IDENTIFIER"
    [menuItems]="menuItems"
    [selectedMenuItem]="selectedMenuItem"
    [canShowDelete]="false"
    [canShowDuplicate]="false"
    [isCreateNewPage]="!isEditingSchedule()"
    [inProgress]="saving"
    (selectedMenuItemChange)="onSelectedMenuItemChange($event)"
    (saveEvent)="saveSchedule(SAVE_TYPE.SAVE)"
    (saveAndCloseEvent)="saveSchedule(SAVE_TYPE.SAVE_AND_CLOSE)"
    (saveAndCreateNewEvent)="saveSchedule(SAVE_TYPE.SAVE_AND_CREATE_NEW)"
    (cancelEvent)="cancel()"
    (settingsEvent)="openCustomSettings()"
  ></vdw-editor-header>
  <div class="bms-theme flex-column p-48 page-content-wrapper flex-grow overflow-auto">
    @if (canShowFormBasedOnTab(TABS.GENERAL)) {
      <form [formGroup]="addScheduleForm" class="full-height flex-row gap-64" appBreadcrumbFormLinker>
        <div class="two-fifth-width">
          <vdw-string-input
            formControlName="name"
            [label]="'GENERAL.NAME' | bmsTranslate"
            [placeholder]="'GENERAL.NAME_PLACEHOLDER' | bmsTranslate: {object: SCHEDULE_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase}"
          >
            <ng-container error>
              <vdw-invalid-form-message *vdwCanShowErrorForFormControl="'name'; error: 'required'" [message]="'GENERAL.ERRORS.REQUIRED' | bmsTranslate" [compact]="true"></vdw-invalid-form-message>
              <vdw-invalid-form-message
                *vdwCanShowErrorForFormControl="'name'; error: 'identifierTaken'"
                [message]="'GENERAL.ERRORS.NAME_DUPLICATE' | bmsTranslate"
                [compact]="true"
                [link]="getLoadLink()"
                [loadEntry]="getLoadEntry()"
              ></vdw-invalid-form-message>
              <vdw-invalid-form-message
                *vdwCanShowErrorForFormControl="'name'; error: 'noSpace'"
                [message]="'GENERAL.ERRORS.NON_EMPTY' | bmsTranslate: {label: 'GENERAL.NAME' | bmsTranslate | lowercase}"
                [compact]="true"
              ></vdw-invalid-form-message>
            </ng-container>
          </vdw-string-input>
        </div>
        <div class="three-fifth-width flex-column gap-4">
          <p class="b2 required">{{ PATTERN_TRANSLATION_KEY | bmsTranslate: {count: 2} }}</p>
          <ag-grid-angular class="full-width full-max-height ag-auto-grow-grid-height" [rowData]="patternsConfig.rowData" [gridOptions]="patternsConfig.gridOptions" />
          <div class="flex-end-center">
            <button mat-button type="button" (click)="addPattern()">
              <mat-icon svgIcon="solid-add"></mat-icon>
              {{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: PATTERN_TRANSLATION_KEY | bmsTranslate: {count: 1} | lowercase} }}
            </button>
          </div>
        </div>
      </form>
    } @else if (canShowFormBasedOnTab(TABS.SCHEDULE)) {
      <app-schedule class="full-height"></app-schedule>
    } @else if (canShowFormBasedOnTab(TABS.MATCHING_CRITERIA)) {
      <app-matching-criteria
        [showMachineGroup]="true"
        [matchingcriteriaData]="matchingCriteriaData"
        [matchingCriteria]="matchingCriteria"
        [editPermission]="getSchedulePermission()"
        (matchingCriteriaChange)="matchingCriteria = $event"
        class="full-width full-height"
      ></app-matching-criteria>
    }
  </div>
</section>
